import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { ApiRequestStatus } from '../enums/apiRequestStatus';
import { getCreditSummaryAsync } from '../slices/pcsSlice';

export const useGetCreditSummary = (personId: string | null) => {
    const dispatch = useAppDispatch();
    const { summaryData, getCreditSummaryStatus } = useAppSelector(state => state.pcs);

    useEffect(() => {
        if (personId && summaryData === null && getCreditSummaryStatus === ApiRequestStatus.Idle) {
            dispatch(getCreditSummaryAsync(personId));
        }
    }, [summaryData, getCreditSummaryStatus, dispatch]);

    return { getCreditSummaryStatus };
};
